// CRA inlines `process.env.REACT_APP_*` at build time. Do not use optional
// chaining on `process` — webpack won't replace it and the browser throws
// "process is not defined" at runtime.
const AUTH_USERNAME = process.env.REACT_APP_AUTH_USERNAME
const AUTH_PASSWORD = process.env.REACT_APP_AUTH_PASSWORD

export function hasBasicAuth() {
    return Boolean(AUTH_USERNAME && AUTH_PASSWORD)
}

// The browser's CORS preflight cannot send Authorization, and Apache rejects
// that OPTIONS request. In local dev, call the dev server instead so it can
// attach Basic auth when it forwards to the protected host.
export function usesDevAuthProxy() {
    return process.env.NODE_ENV === 'development' && hasBasicAuth()
}

export function developmentProxyUrl(absoluteUrl) {
    if (!usesDevAuthProxy() || !absoluteUrl) {
        return absoluteUrl
    }
    try {
        const parsed = new URL(absoluteUrl)
        return parsed.pathname.replace(/\/$/, '') + parsed.search
    } catch (error) {
        return absoluteUrl
    }
}

// Apache basic auth and the app token share the Authorization header.
// When Apache credentials are set, Authorization is Basic and the app token
// moves to X-Authorization. Omit bearerToken to leave the app token off.
export function authorizationHeaders(bearerToken) {
    if (hasBasicAuth()) {
        const headers = {
            Authorization: `Basic ${btoa(`${AUTH_USERNAME}:${AUTH_PASSWORD}`)}`,
        }
        if (bearerToken) {
            headers['X-Authorization'] = `Bearer ${bearerToken}`
        }
        return headers
    }

    if (bearerToken !== undefined) {
        return { Authorization: `Bearer ${bearerToken}` }
    }

    return {}
}
